<template>
  <a-modal :open="open" :title="null" :footer="null" @cancel="handleClose">
    <section class="container">
      <DeleteOutlined class="icon" />

      <h2>¿Estás segura de eliminar “{{ bot?.name }}”</h2>

      <p class="text-center">
        Recuerda que no podrás recuperar este IVR más adelante. Además, se liberarán los siguientes
        identificadores de llamada entrante (Dids), permitiendo que puedan volver a vincularse a
        otro IVR o a una cola:
      </p>

      <div class="identifier-box">
        <h4 class="font-semibold">Identificadores liberados:</h4>

        <p v-for="(item, idx) in identifiersFormatted" :key="idx">
          {{ item.alias }} <span class="identifier">({{ item.associate }})</span>
        </p>
      </div>

      <a-button class="button" type="primary" @click="onDelete(props.bot.id)" :loading="isLoading">
        Eliminar
      </a-button>
      <a-button class="button" @click="handleClose">Cancelar</a-button>
    </section>
  </a-modal>
</template>

<script setup lang="ts">
import { DeleteOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { ref, toRefs } from "vue";

import { Bot } from "@/@types/ivr";
import { botServices } from "@/app/ivr/bot/services/BotServices";

const props = defineProps<{
  open: boolean;
  bot: Bot;
}>();

const { bot } = toRefs(props);

const emit = defineEmits<{
  "update:open": [open: boolean];
  delete: [];
}>();

const handleClose = () => {
  emit("update:open", false);
};

const isLoading = ref<boolean>(false);

const identifiersFormatted = bot.value?.channels_customers.map((item) => {
  return {
    associate: item.associate,
    alias: item.alias,
  };
});

const onDelete = async (ivrId: number) => {
  try {
    isLoading.value = true;
    await botServices.delete(ivrId);
    message.success("Se eliminó exitosamente");
    emit("update:open", false);
    emit("delete");
  } catch (error) {
    message.error("Error al eliminar");
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped lang="sass">
.container
  padding: 24px

.icon
  font-size: 64px
  color: $red-6
  margin-bottom: 16px
  width: 100%
  justify-content: center

h2
  margin-bottom: 12px
  font-size: 16px
  font-weight: 600
  text-align: center

p
  margin-bottom: 12px

.button
  width: 100%
  margin-top: 16px

.text-center
  text-align: center

.text-bold
  font-weight: 600

.identifier-box
  margin-top: 24px
  margin-bottom: 76px

.identifier
  color: #00000073
</style>
